import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'

import { getOrdersList } from '../ordersEndpoints'
import { ordersQueryKeys } from '../ordersQueryKeys'
import type { GetOrdersListParams } from '../../types/orderTypes'

/**
 * `enabled` matters more here than on most list queries: `getOrdersList` strips
 * empty params, so a call made before an `investorId` has resolved does not
 * fetch "that investor's orders, none yet" — it fetches the whole platform's
 * order list. Consumers filtering by a route param must gate on it.
 */
export function useOrdersListQuery(
  params: MaybeRefOrGetter<GetOrdersListParams>,
  enabled?: MaybeRefOrGetter<boolean>,
) {
  return useQuery({
    queryKey: () => ordersQueryKeys.list(toValue(params)),
    queryFn: () => getOrdersList(toValue(params)),
    enabled: () => toValue(enabled) ?? true,
  })
}
